<app-header-style-six></app-header-style-six>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-header-style-two></app-header-style-two>
<app-left-box></app-left-box>